import createAction from '../../common/services/create-action';

export const SET_IS_LOADED = 'isLoaded/SET';

export const setIsLoaded = createAction(SET_IS_LOADED, (entity, id, isLoaded) => ({
  entity,
  id,
  isLoaded,
}));
